var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1092 3.492C5.1092 4.10452 4.61294 4.60118 4.00002 4.60118C3.3873 4.60118 2.89084 4.10452 2.89084 3.492C2.89084 2.87948 3.3874 2.38272 4.00002 2.38272C4.61274 2.38262 5.1092 2.87938 5.1092 3.492ZM7.49192 3.492C7.49192 1.56346 5.92856 0 4.00012 0C2.07158 0 0.508118 1.56346 0.508118 3.492C0.508118 4.94967 1.40156 6.19822 2.67086 6.72105V8.77158L3.78597 9.32918L2.67086 9.88688V10.2069L3.78597 10.7646L2.67086 11.3223V11.6423L3.78597 12.2L2.67086 12.7576V12.9046L4.00012 13.9697L5.32947 12.9046V6.72115C6.59847 6.19832 7.49192 4.94967 7.49192 3.492Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyWhite);
export default __webpack_public_path__ + "static/media/key-white.af2162f75c45563135853b0e6e959854.svg";
export { ForwardRef as ReactComponent };